import { useState } from 'react';
import { useValidateChildCorpNames } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/hooks/useValidateChildCorpNames/useValidateChildCorpNames';
import { childNameErrorsArrayToMap } from 'src/components/enterprise/Parents/Children/ParentChildAccountController/ChildAccountTable/transformationFunctions/childNameErrorsArrayToMap';
import {
  ChildAccountDisplayObject,
  ChildAccountErrorsByName,
} from 'src/components/enterprise/Parents/Children/ParentChildAccountController/types';

type UseCorpNameErrorsProps = {
  parentCorpId: string;
};
export type UseCorpNameErrorsReturn = {
  errorsByName: ChildAccountErrorsByName;
  revalidateForChildAccounts: (
    childAccounts: ChildAccountDisplayObject[]
  ) => void;
  isLoading: boolean;
};

export const useChildCorpNameErrors = ({
  parentCorpId,
}: UseCorpNameErrorsProps): UseCorpNameErrorsReturn => {
  const [errorsByName, setErrorsByName] = useState<ChildAccountErrorsByName>(
    {}
  );

  const { validateChildCorpNames, isLoading } = useValidateChildCorpNames({
    parentCorpId,
    onSuccess: (response) => {
      const errorsByName = childNameErrorsArrayToMap(response);

      setErrorsByName(errorsByName);
    },
  });

  /**
   * Updates the errorsByName by calling the validation API endpoint using the corp names from the arguments
   *
   * Note: Every time you call the revalidateForChildAccounts, you have to call it
   * with all the names in the page in order to catch potential duplications
   */
  const revalidateForChildAccounts = (
    childAccounts: ChildAccountDisplayObject[]
  ) => validateChildCorpNames(childAccounts.map(({ name }) => name));

  return {
    errorsByName,
    revalidateForChildAccounts,
    isLoading,
  };
};
